<style>
.bg-readonly input, .bg-readonly textarea {
    background-color: rgb(235, 235, 235);
}
.remove-button, .add-button {
  font-size: 1.5em;
  background-color: #ff5c5c; /* Red color for remove button */
  color: #fff; /* White text color for buttons */
  border: none;
  cursor: pointer;
  padding: 0.2em 0.5em;
  margin: 0.2em;
  border-radius: 5px;
}
.add-button {
  background-color: #5cb85c; /* Green color for add button */
}
</style>
<template>
    <vx-card :title="'Approval Inbound - Customer Return Form'">
        <div class="vx-row mb-6" style="width: 50%">
            <vs-button class="ml-4 mt-2" color="danger" icon-pack="feather" icon="icon-arrow-left"
                @click="handleBack()">Back</vs-button>
        </div>
        <div class="vx-row mb-6" style="width: 50%">
            <div class="vx-col sm:w-1/3 w-full flex items-center">
                <span>Customer/Ship-to Code</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input :value="data.customer_code" :readonly="true" class="w-full bg-readonly"></vs-input>
            </div>
        </div>
        <div class="vx-row mb-6" style="width: 50%">
            <div class="vx-col sm:w-1/3 w-full flex items-center">
                <span>SO/Invoice Code</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input :value="data.so_code" :readonly="true" class="w-full bg-readonly"></vs-input>
            </div>
        </div>
        <div class="vx-row mb-6" style="width: 50%">
            <div class="vx-col sm:w-1/3 w-full flex items-center">
                <span>Sales Return Data</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input :value="data.sales_return_data " :readonly="true" class="w-full bg-readonly"></vs-input>
            </div>
        </div>
        <div class="vx-row mb-6" style="width: 50%">
            <div class="vx-col sm:w-1/3 w-full flex items-center">
                <span>GIR Data</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input :value="data.gir_data " :readonly="true" class="w-full bg-readonly"></vs-input>
            </div>
        </div>
        <div class="vx-row mb-6" style="width: 50%">
            <div class="vx-col sm:w-1/3 w-full flex items-center">
                <span>Posting Date</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <!-- <Date :value="this.data.receive_date" @selected="(val) => {
                    this.data.receive_date = val
                }"></Date> -->
                <vs-input :value="formatDate(data.receive_date) " :readonly="true" class="w-full bg-readonly"></vs-input>
            </div>
        </div>
        <div class="vx-row mb-6" style="width: 50%">
            <div class="vx-col sm:w-1/3 w-full flex items-center">
                <span>Note</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-textarea v-model="data.note_approval" width="100%" :class="statusReadonly ? 'bg-readonly' : ''"/>
            </div>
        </div>
        
        <vs-divider style="width: 100%; margin-left: 0%">Attachment</vs-divider>
        <div class="vx-row mb-3 mt-6 w-4/4" style="width: 100%; margin-left: 0%">
            <div class="vx-col sm:w-1/3 w-full">
                <span>File</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <div class="vx-col sm:w-4/5 w-full">
                <input
                    id="fileInput"
                    name="file"
                    class="w-full inputx"
                    type="file"
                    ref="file"
                    accept=".jpg, .jpeg, .png, .pdf"
                    multiple
                />
                </div>
            </div>
        </div>

        <div class="vx-row mb-3 mt-6 w-4/4" style="width: 100%; margin-left: 0%">
            <div class="vx-col sm:w-1/3 w-full">
                <span></span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <div class="vx-col sm:w-4/5 w-full">
                <vs-button class="mr-3 mb-2" @click="handleAttachment"
                    >Add Attachment</vs-button
                >
                </div>
            </div>
        </div>

        <vs-divider style="width: 100%; margin-left: 0%"
        >List Attachment</vs-divider
        >
        <div class="vx-row mb-3 mt-6 w-4/4" style="width: 100%; margin-left: 0%">
            <table class="vs-table vs-table--tbody-table">
                <template v-for="(tr, i) in data.file">
                <tr
                    class="tr-values vs-table--tr tr-table-state-null selected"
                    v-bind:key="tr.name"
                >
                    <td class="td vs-table--td">{{ tr.name }}</td>
                    <td class="td vs-table--td">
                    <vx-tooltip text="Download" v-if="tr.path != ''">
                        <vs-button
                        type="line"
                        icon-pack="feather"
                        @click.stop="downloadFileAwsS3(tr.path)"
                        icon="icon-download"
                        />
                    </vx-tooltip>
                    </td>
                    <td class="td vs-table--td">
                    <template>
                        <vx-tooltip text="Delete">
                        <vs-button
                            type="line"
                            icon-pack="feather"
                            @click.stop="handleDeleteAttachment(i, tr.id)"
                            icon="icon-trash"
                        />
                        </vx-tooltip>
                    </template>
                    </td>
                </tr>
                </template>
            </table>
        </div>
        
        <vs-divider style="width: 100%; margin-left: 0%">Log Approval</vs-divider>
          <vs-table
            stripe
            border
            description
            :sst="true"
            :data="data.historyNotes"
          >
            <template slot="thead">
              <vs-th>Time</vs-th>
              <vs-th>User</vs-th>
              <vs-th>Status & Note</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td class="whitespace-no-wrap">{{ formatDateTime(tr.created_at) }}</vs-td>
                <vs-td class="whitespace-no-wrap">{{ tr.personal_name }}</vs-td>
                <vs-td class="whitespace-no-wrap">{{ tr.type }}. {{ tr.notes }}</vs-td>
              </vs-tr>
            </template>
        </vs-table>

        <vs-divider style="width: 100%; margin-left: 0%"></vs-divider>
        <div class="vx-row mb-6">
            <div class="vx-col w-full mb-6">
                <table width="100%" class="vs-table vs-table--tbody-table mb-6">
                    <thead class="vs-table--thead">
                        <tr>
                            <th width="7%">SKU Code</th>
                            <th width="15%">SKU Description</th>
                            <th width="5%">Return HU</th>
                            <th width="4%">Return Qty</th>
                            <template v-if="data.shipment_number !== '' && data.shipment_number !== null">
                                <th width="4%">Pickup Qty</th>
                            </template>
                            <th width="12%">Supplier</th>
                            <th width="6%">Receive HU</th>
                            <th width="5%">Receive Qty</th>
                            <th width="5%">Delta Qty Pcs</th>
                            <th width="10%">ED</th>
                            <th width="8%">Batch</th>
                            <th width="10%">Checked Status</th>
                            <th width="7%">Shelf Life Status</th>
                        </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in items" :key="index" style="padding-bottom: 5px">
                        <td class="td vs-table--td" style="padding: 5px">
                          <vs-input :value="item.item_code" :readonly="true" class="w-full bg-readonly" v-show="!item.hideFields"></vs-input>
                        </td>
                        <td class="td vs-table--td" style="padding: 5px">
                          <vs-input :value="item.item_name" :readonly="true" class="w-full bg-readonly" v-show="!item.hideFields"></vs-input>
                        </td>
                        <td class="td vs-table--td" style="padding: 5px">
                          <vs-input :value="item.item_unit" :readonly="true" class="w-full bg-readonly" v-show="!item.hideFields"></vs-input>
                          <input type="hidden" :value="item.item_unit_id" />
                        </td>
                        <td class="td vs-table--td" style="padding: 5px">
                          <vs-input :value="item.quantity" :readonly="true" class="w-full bg-readonly" v-show="!item.hideFields"></vs-input>
                        </td>
                        <template v-if="item.pickup_qty !== 0 && data.shipment_number !== '' && data.shipment_number !== null">
                            <td class="td vs-table--td" style="padding: 5px">
                                <vs-input :value="item.pickup_qty" :readonly="true" class="w-full bg-readonly" v-show="!item.hideFields"></vs-input>
                            </td>
                        </template>
                        <td class="td vs-table--td" style="padding: 5px">
                            <vs-input :value="item.supplier_name" :readonly="true" class="w-full bg-readonly"></vs-input>
                        </td>
                        <td class="td vs-table--td" style="padding: 5px">
                            <vs-input :value="item.unit_name_receive" :readonly="true" class="w-full bg-readonly"></vs-input>
                        </td>
                        <td class="td vs-table--td" style="padding: 5px">
                          <vs-input type="text" :readonly="true" v-model="item.qty" class="w-full bg-readonly"></vs-input>
                        </td>
                        <td class="td vs-table--td" style="padding: 5px">
                          <vs-input :value="item.delta_quantity" :readonly="true" class="w-full bg-readonly"></vs-input>
                        </td>
                        <td class="td vs-table--td" style="padding: 5px">
                            <vs-input :value="formatDate(item.expired_date)" :readonly="true" class="w-full bg-readonly"></vs-input>
                        </td>
                        <td class="td vs-table--td" style="padding: 5px">
                            <vs-input :value="item.batch" :readonly="true" class="w-full bg-readonly"></vs-input>
                        </td>
                        <td class="td vs-table--td" style="padding: 5px">
                            <vs-input :value="item.checked_status" :readonly="true" class="w-full bg-readonly"></vs-input>
                        </td>
                        <td class="td vs-table--td" style="padding: 5px">
                            <vs-textarea
                                :value="item.shelf_life_status_view"
                                readonly
                                height="80px"
                            />
                        </td>
                      </tr>
                    </tbody>
                </table>
            </div>
        </div>
          <div class="vx-row mb-6" style="width: 50%">
            <div class="vx-col sm:w-1/1 w-full">
                <div
                style="
                    position: absolute;
                    left: 50%;
                    -ms-transform: translate(-50%, -50%);
                    transform: translate(-50%, -50%);
                ">
                    <vs-button class="mr-2 mb-3" color="primary" @click="handleApproval('approve')">Approve</vs-button>
                    <vs-button class="mb-2 mr-3" color="warning" @click="handleApproval('reject')">Reject</vs-button>
                    <vs-button class="mb-2 mr-3" color="success" @click="handleApproval('inquiry')">Inquiry</vs-button>
                </div>
            </div>
        </div>
    </vx-card>
</template>

<script>

import _ from "lodash";
import Warehouse from "@/components/Warehouse.vue";
import Date from "@/components/Date.vue";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import CustomMSelect from "@/components/CustomMultiSelect.vue";
import SupplierSelect from "./component/Supplier.vue";

import vSelect from "vue-select";
export default {
    components: {
        Warehouse,
        Date,
        Datepicker,
        vSelect,
        CustomMSelect,
        SupplierSelect
    },
    data() {
        return {
            data: {
                id: null,
                customer_code: null,
                so_code: null,
                code: null,
                gir_number: null,
                sales_return_data: null,
                gir_data: null,
                sales_return_id: null,
                sales_return_code: null,
                receive_date: null,
                note: null,
                status: null,
                srr_id: null,
                tpr_id: null,
                parent_id: null,
                fileUrl: '',
                setting: '',
                shipment_number: '',
                note_approval: null,
                file: [],
                historyNotes: [],
                attachment_ids: [],
              },
            items: [],
            statusOptions: [
                { label: 'Good', value: 'Good' },
                { label: 'Bad', value: 'Bad' },
                { label: 'Expired', value: 'Expired' },
            ],
            statusReadonly: false,
            stsDisable: false,
        }
    },
    mounted() {
        // var now = moment()
        // this.data.receive_date = now
        // now.add(1, 'days')

        this.id = this.$route.params.id;
        if (this.id) { // sto id
            this.getData()
        }
    },
    methods: {
        getData() {
          console.log('tes',this.$store.state.inbound.customerReturn.baseUrlPath  + "/" + this.id)
            this.$vs.loading();
            this.$http
                .get(this.$store.state.inbound.customerReturn.baseUrlPath + "/" + this.id)
                .then((resp) => {
                    if (resp.code == 200) {
                        console.log("data parent",resp.data)
                        var now = moment().toDate();
                        this.data.parent_id = resp.data.parent_id
                        this.data.id = resp.data.sr_id
                        this.data.customer_code = resp.data.customer_code
                        this.data.so_code = resp.data.so_code
                        this.data.so_id = resp.data.so_id
                        this.data.sales_return_data = resp.data.sales_return_code + " " + resp.data.gir_number
                        this.data.gir_data = resp.data.code
                        this.data.sales_return_id = resp.data.sales_return_id
                        this.data.sales_return_code = resp.data.sales_return_code
                        this.data.code = resp.data.code
                        this.data.gir_number = resp.data.gir_number
                        this.data.receive_date = resp.data.receive_date == null ? now : resp.data.receive_date
                        this.data.tpr_id = resp.data.tpr_id != 0 ? resp.data.tpr_id : 0
                        this.data.note = resp.data.note
                        this.data.status = resp.data.status
                        this.data.srr_id = resp.data.srr_id
                        this.data.wh_id = resp.data.wh_id   
                        this.data.setting = resp.data.setting.value
                        this.data.shipment_number = resp.data.shipment_number
                        console.log("setting putaway",this.data.setting)
                        var sameitem = ""
                        var totdelta = 0
                        var hasildelta = 0
                        this.data.historyNotes = resp.data.history_notes
                        // console.log("TIME APPROVE",resp.data.history_notes[0].CreatedAt)
                        resp.data.attachments.map((r,i) => {
                            this.data.file.push({
                                id: r.id,
                                name: r.name,
                                path: r.path,
                            })
                        })
                        resp.data.lines.forEach(el =>{
                            let expired_date = null
                            let batch = ""
                            console.log('ed',el.expired_date)
                            if(el.is_expired == "0" && el.expired_date == "0001-01-01T00:00:00Z"){
                                expired_date = moment().add(1, 'years').format('YYYY-MM-DD');
                            } else if(el.expired_date == "0001-01-01T00:00:00Z"){
                                expired_date = null
                            } else {
                                expired_date = el.expired_date
                            }
                            if(el.batch == "0000"){
                                batch = ""
                            } else {
                                batch = el.batch
                            }
                            totdelta += el.delta_quantity
                            hasildelta = el.return_qty - el.qty
                            let status_shelf_life_view = ""

                            if (el.shelf_life_status) {
                                const status = el.shelf_life_status.toLowerCase();

                                if (status.includes("passed")) {
                                    status_shelf_life_view = "Passed";
                                } else if (status.includes("failed")) {
                                    status_shelf_life_view = `Shelf Life < ${el.shelf_life_day} Day`;
                                }
                            }
                          const newItem = {
                            item_code: el.item_code,
                            item_name: el.item_name,
                            item_unit: el.item_unit,
                            item_unit_id: el.item_unit_id,
                            qty: el.qty,
                            quantity: el.return_qty,
                            pickup_qty: el.pickup_qty,
                            delta_quantity: el.delta_quantity,
                            delta_quantity_parent: el.return_qty,
                            // delta_quantity: 0,
                            setting_ed: el.is_expired,
                            setting_batch: el.name,
                            batch: batch,
                            expired_date: expired_date,
                            checked_status: el.checked_status,
                            hideFields: (sameitem == el.item_code + el.item_unit + el.return_qty) ? true : false,
                            child_item : false,
                            supplier_name: el.supplier_name,
                            supplier_code: el.supplier_code,
                            supplier_id: el.supplier_id,
                            item_id: el.item_id,
                            amount_uom_receive: el.amount_uom,
                            unit_name_receive: el.unit_name,
                            item_unit_receive: {
                                amount_uom: el.amount_uom,
                                id: el.item_unit_id,
                                item_id: el.item_id,
                                level: el.level,
                                name: el.unit_name,
                                unit_id: el.unit_id
                            },
                            supplier: {
                                id: el.supplier_id,
                                code: el.supplier_code,
                                name: el.supplier_name
                            },
                            return_amount_uom: el.return_amount_uom,
                            sales_return_line_id: el.sales_return_line_id,
                            shelf_life_id: el.shelf_life_id,
                            shelf_life_day: el.shelf_life_day,
                            shelf_life_status: el.shelf_life_status,
                            shelf_life_status_view: status_shelf_life_view,
                            shelf_life_passed: el.shelf_life_passed,
                            sales_return_receive_line_id: el.srrl_line_id,
                          }
                          this.items.push(newItem)
                          sameitem = el.item_code + el.item_unit + el.return_qty
                        })
                        if(this.data.parent_id == 0 && totdelta > 0){
                            this.stsDisable = true
                        }
                        this.data.fileUrl = resp.data.file_url
                        this.$vs.loading.close();
                    } else {
                        this.$vs.loading.close();
                    }
                });
        },
        handleBack() {
            this.$router.push({
                name: "approval.inbound-sales-return",
            });
        },
        handleApproval(status){
            console.log("ATTACHMENT IDS",this.data.attachment_ids)
            var status_approval = 1
            var message = ""
            var title = ""
            if(status == 'approve'){
                status_approval = 7
                message = "approve ?"
                title = "Confirm Approve"
            } else if(status == 'reject'){
                status_approval = 8
                message = "reject ?"
                title = "Confirm Reject"
            } else {
                message = "inquiry ?"
                title = "Confirm Inquiry"
            }

            this.$vs.dialog({
                type: "confirm",
                color: "primary",
                title: title,
                text: 'Are you sure want to ' + message,
                accept: () => {
                    this.$nextTick(() => {
                        this.handleSubmit(status_approval);
                    })
                },
            });
        },
        handleSubmit(status_approval) {
            this.data.status = status_approval,
            this.data.confirm = 1

            let itemsMap = {};
            this.items.forEach((item, index) => {
                let key = `${item.item_code}-${item.item_unit}`;
                if (!itemsMap[key]) {
                    itemsMap[key] = [];
                }
                itemsMap[key].push(index);
            });
            this.items.forEach((val, i) => {
                let key = `${val.item_code}-${val.item_unit}`;
                let indices = itemsMap[key];
                let lastIndex = indices[indices.length - 1];

                if (i === lastIndex && this.items[i].delta_quantity > 0) {
                    this.items[i].is_partial = 1;
                } else {
                    this.items[i].is_partial = 0;
                }
                this.items[i].expired_date = moment(val.expired_date).format('YYYY-MM-DD')
                this.items[i].qty = parseInt(val.qty)
                if(val.checked_status.value != undefined){
                    this.items[i].checked_status = val.checked_status.value
                } else {
                    this.items[i].checked_status = val.checked_status
                }
            })

            let formData = new FormData();
            formData.append("data", JSON.stringify(this.data))
            formData.append("lines", JSON.stringify(this.items))
            console.log('data',JSON.stringify(this.data))
            console.log('lines',JSON.stringify(this.items))
            this.$vs.loading();
            let http = null

            http = this.$http.put(this.$store.state.inbound.customerReturn.baseUrlPath + "/approval" + this.id, formData)

            http.then((resp) => {
                console.log(resp)
                if (resp.code == 200) {
                    this.$vs.notify({
                        color: "success",
                        title: "Success",
                        text: resp.message,
                        position: "top-right",
                        iconPack: "feather",
                        icon: "icon-x-circle",
                    });

                    this.$vs.loading.close();
                    this.draw++;
                    this.handleBack()
                } else {
                    this.$vs.loading.close();
                    this.$vs.notify({
                        color: "danger",
                        title: "Error",
                        text: resp.message,
                        position: "top-right",
                        iconPack: "feather",
                        icon: "icon-x-circle",
                        duration: 10000,
                    });
                }
            })
        },
        openTab(uri) {
            window.open(uri)
        },
        handleDeleteAttachment(index, id) {
            this.data.file = this.data.file.filter((item, i) => i != index);
            this.deleteFile(id);
        },
        handleAttachment() {
            if (this.$refs.file.files[0]) {
                let a = this.$refs.file.files
                for (let i = 0; i < a.length; i++) {
                if(a[i].size <= 5000000){ // 5mb
                    this.file = a[i];
                    this.uploadData();
                } else {
                    this.$vs.notify({
                    title: "Error",
                    text: a[i].name + " is greater than 5MB",
                    color: "danger",
                    position: "top-right",
                    iconPack: "feather",
                    icon: "icon-check",
                    });
                }
                }
                document.querySelector("#fileInput").value = "";
            } else {
                this.$vs.notify({
                title: "Error",
                text: "No file chosen.",
                color: "danger",
                position: "top-right",
                iconPack: "feather",
                icon: "icon-check",
                });
            }
        },
        paramUpload() {
            var form = new FormData();
            form.append("id", this.id);
            form.append("file", this.file);
            form.append("type", this.file.type);
            return form;
        },
        uploadData() {
        this.$vs.loading();
        this.$http
            .post(this.$store.state.inbound.customerReturn.baseUrlPath + "/upload-file", this.paramUpload(), {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            })
            .then((resp) => {
            this.$vs.loading.close();
            console.log("RESP ATTACHMENT",resp)
            if (resp.code == 200) {
                this.data.file.push({
                id: resp.data.attachment.id,
                name: resp.data.attachment.name,
                path: resp.data.attachment.path,
                doc_type: resp.data.attachment.doc_type,
                });
                this.data.attachment_ids.push(parseInt(resp.data.attachment.id))
                this.$vs.notify({
                color: "success",
                title: "Success",
                text: resp.message,
                position: "top-right",
                iconPack: "feather",
                icon: "icon-x-circle",
                });
            } else {
                this.$vs.notify({
                color: "danger",
                title: "Error",
                text: resp.message,
                position: "top-right",
                iconPack: "feather",
                icon: "icon-x-circle",
                });
            }
            })
            .catch((error) => {
            console.log(error)
            this.$vs.loading.close();
            });
        },
        deleteFile(id) {
            this.$vs.loading();
            var form = new FormData();
            form.append("id", id);
            this.$http
                .post(this.$store.state.inbound.customerReturn.baseUrlPath + "/delete-file", form, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                })
                .then((resp) => {
                this.$vs.loading.close();
                if (resp.code == 200) {
                    this.$vs.notify({
                    color: "success",
                    title: "Success",
                    text: resp.message,
                    position: "top-right",
                    iconPack: "feather",
                    icon: "icon-x-circle",
                    });
                } else {
                    this.$vs.notify({
                    color: "danger",
                    title: "Error",
                    text: resp.message,
                    position: "top-right",
                    iconPack: "feather",
                    icon: "icon-x-circle",
                    });
                }
                })
                .catch((error) => {
                console.log(error)
                this.$vs.loading.close();
            });
        },
        formatDateTime(s){
            const m = moment.parseZone(s);
            return m.format('YYYY-MM-DD HH:mm:ss')
        },
    },
    computed: {
        disabledDatesObj() {
            const tomorrow = moment().add(1, 'day').startOf('day').toDate();
            return {
            from: tomorrow
            };
        },
        formatDate: () => {
            return (val) => {
                const momentDate = moment.utc(val);
                return momentDate.format('YYYY-MM-DD');
            };
        },
    },
    watch: {
        // items: {
        //     handler(newItems) {
        //         newItems.forEach(item => {
        //             this.$watch(() => item.qty, (newQty) => {
        //                 item.delta_quantity = item.quantity - newQty;
        //             });
        //         });
        //     },
        //     deep: true,
        //     immediate: true
        // }
    }
}
</script>
